import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IFalgList } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListFlagSlice = createSlice({
  name: "ListFlagSlice",
  initialState: {} as IReduxState<IFalgList[]>,
  reducers: {
    listFlag: (state, _: PayloadAction<IFalgList>) => {
      state.isLoading = true;
    },
    successlistFlag: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistFlag: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistFlag, listFlag, successlistFlag } =
  ListFlagSlice.actions;

export default ListFlagSlice.reducer;
